import { render, staticRenderFns } from "./CreateDetail_TD.vue?vue&type=template&id=e5f229ea"
import script from "./CreateDetail_TD.vue?vue&type=script&lang=js"
export * from "./CreateDetail_TD.vue?vue&type=script&lang=js"
import style0 from "./CreateDetail_TD.vue?vue&type=style&index=0&id=e5f229ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports